import { AfterViewInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Intervention } from 'src/app/domain/intervention';
import { Zone } from 'src/app/domain/zone';
import { InterventionService } from 'src/app/services/intervention.service';
import { ChangeLetterDialog } from 'src/app/tools/ui/change-letter-box/change-letter-box';
import { ChangeMapDialog } from 'src/app/tools/ui/change-map-box/change-map-box';
import { ChangeProcessDialog } from 'src/app/tools/ui/change-process-box/change-process-box';
import { ChangeZoneDialog } from 'src/app/tools/ui/change-zone-box/change-zone-box';
import { ExoticCreationDialog } from 'src/app/tools/ui/exotic-creation-box/exotic-creation-box';
import { BaseComponent } from '../base/base.component';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { ZoneService } from 'src/app/services/GSP/zone.service';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { ELIMSJobService } from 'src/app/services/elims-job.service';
import { EElimsAggregatedStatus } from 'src/app/domain/enums/elims-aggregate-status';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';

@Component({
    selector: 'app-intervention',
    templateUrl: './intervention.component.html',
    styleUrls: ['./intervention.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InterventionComponent extends BaseComponent implements OnInit, AfterViewInit {
    EElimsAggregatedStatus = EElimsAggregatedStatus;
    private interventionCode!: string;
    public Intervention!: Intervention;
    public Date: Date = new Date();
    public DateTime: any;

    constructor(
        private snackBar: MatSnackBar,
        private router: Router,
        protected override coreData: CoreData,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private interventionService: InterventionService,
        private jobService: ELIMSJobService,
        private zoneService: ZoneService) {
        super(coreData);
    }

    ngOnInit(): void {

    }

    ngAfterViewInit(): void {
        this.interventionCode = this.route.snapshot.params['interventionCode'];
        this.getIntervention();
    }

    getSequenceLevelError(status: EElimsAggregatedStatus) {
        switch (status) {
            case EElimsAggregatedStatus.ElimsBatchError:
                return 'ElimsBatchError'
            case EElimsAggregatedStatus.FinalizedIntercoError:
                return 'FinalizedIntercoError'
            case EElimsAggregatedStatus.ValidatedResultError:
                return 'ValidatedResultError'
            case EElimsAggregatedStatus.RegisteredSampleError:
                return 'RegisteredSampleError'
        }
        return 'fewf'
    }

    moveDepose(zoneCode: string) {
        this.zoneService.moveZoneOnDate(zoneCode, this.Date).subscribe(x => {
            if (x) {
                this.getIntervention();
                NotificationManager.handleSuccess('Zone déplacée', this.snackBar);
            }
        })
    }

    getIntervention() {

        this.interventionService.getInterventionByCode(this.interventionCode).subscribe(x => {
            this.Intervention = x;
            this.Date = this.convertTemporalToDate(this.Intervention.PlannedOn.add({ days: 1 }))
        })
    }

    openExoticCreationBox() {
        const dialogRef = this.dialog.open(ExoticCreationDialog, {
            data: this.interventionCode,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getIntervention();
            }
        });
    }

    openChangeLetterBox(samplingId: number, isForProcess: boolean) {
        const dialogRef = this.dialog.open(ChangeLetterDialog, {
            data: {
                interventionCode: this.interventionCode,
                strategyType: this.Intervention.Strategy.Type,
                samplingId: samplingId,
                isForProcess: isForProcess
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getIntervention();
            }
        });
    }

    openChangeMapBox(samplingId: number) {
        const dialogRef = this.dialog.open(ChangeMapDialog, {
            data: {
                interventionCode: this.interventionCode,
                samplingId: samplingId
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getIntervention();
            }
        });
    }

    openChangeZoneBox(zoneSource: Zone) {
        const dialogRef = this.dialog.open(ChangeZoneDialog, {
            data: {
                interventionCode: this.interventionCode,
                zoneSource: zoneSource
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getIntervention();
            }
        });
    }

    openChangeProcessBox(samplingId: number) {
        const dialogRef = this.dialog.open(ChangeProcessDialog, {
            data: {
                interventionCode: this.interventionCode,
                samplingId: samplingId
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.getIntervention();
            }
        });
    }

    editMap(areaMapId: number) {
        this.router.navigate([ENavigationRoute.DrawingTool, { areaMapId: areaMapId, interventionCode: this.interventionCode }]);
    }

    resetCodage() {
        this.jobService.reset(this.Intervention.Code).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Jobs relancés', this.snackBar)
            }
        })
    }

    public navigateToDemetra() {
        window.open(`${environment.demetraUrl}order;id=${this.Intervention.Strategy.Id};interventionId=${this.Intervention.Code}`, '_blank');
    }
}
